<template>

<div v-if="activeStoreUsers.length > 1" class="main-div" v-bind:class="{ 'bottom-left': !showDetail && (!displayPdChart || !isRosterRoute), 'middle-left': !showDetail && displayPdChart && isRosterRoute, 'bottom-right': showDetail }">
    <button class="square-button symbol-button" v-bind:class="{ blink_me: newMessageCount > 0 }" v-if="!showDetail && activeStoreUsers.length > 0"  @click="toggleShowDetail()">
        <div class="online-users" v-if="$store.state.isSuperUser ? activeStoreUsers.length > 1 : activeStoreUsers.filter(u => !u.hidden).length > 1">{{activeStoreUsers.length}}</div>
        <i class="cog-icon fa-2x fas fa-comments"></i>
    </button>
    <div v-if="newMessageCount > 0" class="notification" v-bind:class="{big: newMessageCount > 99}">{{ newMessageCount > 99 ? '99+' : newMessageCount }}</div>
    <div v-if="showDetail" v-bind:style="{height: CheckHeight()}">
        <div v-bind:class="{'show-users': showUsers}" class="card-body">
            <div class="header">
                <labelc type="header" style="color: white" text="STORE CHAT"/>
                <div class="fa-stack cancel" @click="toggleShowDetail()">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-times fa-stack-2x"></i>
                </div>
            </div>
            <div class="message-container" >
                <div class="message" v-bind:class="{'sender': msg.myself}" v-bind:key="msg.id+'-'+msg.date" v-for="msg in messages">
                    <employeepicture v-if="activeStoreUsers.find(u => u.name === msg.name)" :pictureUrl="activeStoreUsers.find(u => u.name === msg.name).imgUrl"  />
                    <labelc class="time-stamp" v-bind:class="{'others': msg.myself}" :text="msg.moment.format('HH:mm')"/>
                    <labelc class="text" type="selectable" :text="msg.msg"/>
                </div>
            </div>
            <div class="user-list" v-bind:class="{'collapsed': $store.state.isSuperUser ? activeStoreUsers.length > 6 : activeStoreUsers.filter(u => !u.hidden).length > 6, minimized: !showUsers}">
                <div class="user" :key="user.id" v-for="user in ($store.state.isSuperUser ? activeStoreUsers : activeStoreUsers.filter(u => !u.hidden))" v-tooltip="user.name">
                    <employeepicture :pictureUrl="activeStoreUsers.find(u => u.name === user.name).imgUrl"/>
                    <!-- <labelc class="title" :type="'no-break ' + (showUsers ? 'shadow' : 'center-absolute tiny')" :text="showUsers ? user.name : user.name[0]"/> -->
                </div>
            </div>
            <div class="my-1 chat-input">
                <input type="text" v-model="messageInput" v-on:keyup.enter="submitMessage()" />
                <buttonc class="chat-button" type="square" icon="fa-paper-plane" @click="submitMessage()"/>
                <buttonc class="chat-button" type="square" icon="fa-laugh" @click="OpenEmotSelection($event)"
                    style="color: var(--col-warning)"/>
            </div>
        </div>
    </div>
    
    
</div>

</template>

<script>
import VueEventBus from '../../vue-event-bus';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'userchat',
    components: {
    },
    data () {
        return {
            windowHeight: window.innerHeight,
            showDetail: false,
            error: false,
            errorMsg: "",
            messageInput: "",
            messages: [],
            newMessageCount: 0,
            showUsers: false,
            unicodeEmotList: [
                '😃', '😄', '😅', '😆', '😊', '😁', '😀', '😂', '🤔', '😛', '😜', '😦', '😞','😥', '😟', '😩', '😫', '😪', '😴', '😵', '👍', '👎', '👌', '✋', '🤞', '👀',
            ],
        }
    },
    computed: {
       ...mapGetters(['loggedIn', 'storeId', 'userInfo', 'activeStoreUsersMap', 'displayPdChart', 'rosterView']),
        activeStoreUsers(){
            return Object.values(this.activeStoreUsersMap).filter(u => u !== undefined);
        },
        isRosterRoute() {
            return this.$route.name == "planning" && this.rosterView;
        },
    },
    watch: {
        storeId(newVal, oldVal) {
            this.messages = [];
        },
    },
    created: function () {
        //listen to vue eventbus for events from wizard and from vertx eventbus
        VueEventBus.$on("chatmessage-received", this.receiveChatMessage);    
        document.addEventListener('keydown', this.EscapeHandler);
        
    },
    mounted: function() {
 
    },
    beforeDestroy() {
       VueEventBus.$off("chatmessage-received", this.receiveChatMessage); 
        document.removeEventListener('keydown', this.EscapeHandler);   
        
    },
  // methods that implement data logic.
  methods: {
  
    EscapeHandler($event){
        if($event.key === 'Escape'){
            this.showDetail = false;
        }
    },
    onResizeWindow() {
        this.windowHeight = window.innerHeight;
    },
    OpenEmotSelection($event){
        let view = this;
        this.$helpers.OpenPopup({
            type: 'emotlist',
            componentState: {
                unicodeList: view.unicodeEmotList,
            },
            customEventName: 'append',
            customEventHandler: view.AppendUnicode,
            noScroll: true,
            elRelative: $event.currentTarget,
            pointerDirection: 0,
            listStyle: true,
            indexOverride: true,
        });
    },
    AppendUnicode(unicode){
        this.messageInput += unicode;
    },
    toggleShowDetail(){
        this.showDetail = !this.showDetail;
        if(this.showDetail){
            this.newMessageCount = 0;
        }
    },
    submitMessage(){
        let msg = {
            msg: this.messageInput,
            resolve: null,
            reject: null,
        }
        let promise = new Promise((resolve, reject) => {
            msg.resolve = resolve;
            msg.reject = reject;
        });
        VueEventBus.$emit("send-chatmessage", msg);
        promise.catch(error => {
            console.log("error sending msg");
        })
        this.messageInput = "";
    },
    receiveChatMessage: function(payload) {
        if(payload.id == this.userInfo.id){
            payload.myself = true;
        }
        payload.moment = this.$helpers.getMomentFromStringTZ(payload.date);
        this.messages.push(payload);
        if(this.messages.length > 30){
            this.messages = this.messages.splice(-30);
        }
        if(!this.showDetail){
            this.newMessageCount = this.newMessageCount +1;
        }
        let view = this;
        requestAnimationFrame(function() {
            let container = view.$el.querySelector('.message-container');
            if(container) container.scrollTop = container.scrollHeight
        });
    },
      CheckHeight(){
          let view = this;
          let box = this.$el.getBoundingClientRect();
          return (window.innerHeight - box.top - 5) + 'px';
      },
      ToggleUserList(){
          this.showUsers = !this.showUsers;
          let view = this;
          view.$children.filter(c => c.GetShadowStyle).forEach(c => c.GetShadowStyle('#6d8d23'));
      },
    
  }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>

.blink_me {
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
            box-shadow: inset 0 0 10px 10px #f43535;
    }
}

.container-fluid {
    padding-left: 0px;
}

.notification, .online-users {
        position: absolute;
        background: #f43535;
        color: #ffffff;
        height: 16px;
        width: 16px;
        font-size: 8px;
        text-align: center;
        top: -8px;
        right: -8px;
        border-radius: 100px;
        display: flex;
        align-items: baseline;
        justify-content: center;
    }

.online-users{
    top: initial;
    bottom: -8px;
    background: #6d8d23;
    font-size: 10px;
}

.notification.big{
        height: 17px;
        width: 17px;
        font-size: 8px;
        text-align: center;
        top: -8px;
        right: -8px;
}
.main-div {
    display: inline-block;
    position: fixed;
    border-radius: 0;
}

.card-body{
    border: none;
    border-radius: 0;
    min-height: 60vh;
    background-color: var(--bg);
    /* padding-bottom: 65px;
    padding-top: 55px; */
    position: relative;
    overflow: hidden;
    height: 60vh;
    padding-left: 0;
    padding-right: 0;
}
.cog-icon {
    color: #404040;
}
.bottom-left {
    z-index: 100;
    top: auto;
    left: auto;
    bottom: 58px;
    right: 28px;
}

.middle-left {
    z-index: 100;
    top: auto;
    left: auto;
    bottom: 348px;
    right: 28px;
}
.bottom-right {
    z-index: 1000000;
    width: 400px;
    top: 40vh;
    left: auto;
    bottom: auto;
    right: 18px;
    margin-right: -16px;
    -webkit-box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.2), 0 -6px 6px rgba(0, 0, 0, 0.23);
    -moz-box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.2), 0 -6px 6px rgba(0, 0, 0, 0.23);
    -ms-box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.2), 0 -6px 6px rgba(0, 0, 0, 0.23);
    -o-box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.2), 0 -6px 6px rgba(0, 0, 0, 0.23);
    box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.2), 0 -6px 6px rgba(0, 0, 0, 0.23);
}
.square-button {
    height: 52px !important;
    width: 52px !important;
    padding-top: 0rem;
    padding-right: 0rem;
    padding-bottom:0rem;
    padding-left: 0rem;
    background-color: #c1c1c1;
    border-color: #c1c1c1;
    
}
.close-button {
    height: 20px !important;
    width: 20px !important;
}

.message{
    background: var(--contrast-1);
    padding: 10px;
}
.message{
    background: var(--contrast-1);
    color: var(--contrast-4);
    padding: 10px;
    margin-top: 20px;
    width: calc(100% - 100px - 40px);
    margin-left: 90px;
    position: relative;
    margin-bottom: 10px;
    /*box-shadow: 5px 5px 10px 0px rgba(0,0,0,.1);*/
}
    .message.sender{
        margin-left: 50px;
    }


.message-info{
    margin-bottom: 10px;
    padding: 0 5px;
    position: absolute;
    left: -20px;
    top: -30px;
    height: 30px;
    width: calc(100% + 60px);
    display: flex;
    align-content: center;
    margin-left: 0;
    justify-content: flex-start;
    flex-direction: row-reverse;
}

.sender .message-info{

    flex-direction: row;
}

.message-info > *{
    position: relative;
}

.title{
    width: initial;
}

.time-stamp{
    display: flex;
    position: absolute;
    right: 4px;
    top: 2px;
    font-size: 8px;
    margin-left: 10px;
    align-content: center;
    font-weight: 200;
    font-family: DistrictProLight;
}

.time-stamp.others{
    display: flex;
    position: absolute;
    left: 4px;
    top: 2px;
    font-size: 8px;
    margin-left: 10px;
    align-content: center;
    font-weight: 200;
    font-family: DistrictProLight;
}

.spacer{
    margin: 0 !important;
}


    .text{

    }

.main-div .picture{
    position: absolute;
    right: -35px;
    top: 5px;
    height: 30px;
    width: 30px;
    z-index: 2;
}

.main-div .sender .picture{
    right: initial;
    left: -35px;
}

    .chat-input{
        box-shadow: 0 -2px 0 -1px var(--contrast-3);
        background-color: var(--contrast-1);
        color: var(--contrast-4);
        margin: 0 !important;
        padding: 5px;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }

    input{
        background-color: var(--bg);
        color: var(--contrast-4);
        border: none !important;
        box-shadow: none !important;
        box-shadow: 0 2px 0 -1px var(--contrast-2) !important;
        border-radius: 0 !important;

        margin-left: 5px;
        margin-bottom: 5px;
        height: 33px;
        width: calc(100% - 60px - 45px);
    }

.chat-button {
    height: 35px !important;
    width: 35px !important;
    background-color: var(--md);
    color: white;
}

    .fa-stack.cancel {
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(1);
        margin: 0;
    }

    .fa-stack.cancel .fa-circle {
        color: transparent;
        font-size: 22px;
        transform: translateY(2px);
    }

    .fa-stack.cancel .fa-times {
        font-size: 16px;
        transform: translateY(5px);
        color: white;

    }

    .fa-stack.cancel:hover .fa-circle {
        color: var(--contrast-3);
    }

    .fa-stack.cancel:hover .fa-times {
        color: white;
    }

    .header{
        width: 100%;
        height: 30px;
        position: absolute;
        top: 0;
        left: 0;
        margin: 0;
        /*box-shadow: 0 2px 0 -1px var(--contrast-1);*/
        background: #6d8d23;
        padding: 5px 10px 0px 10px;
    }

    .message-container{
        overflow-y: scroll;
        height: calc(100% - 80px);
        position: relative;
        width: 100%;
        top: 50px;
    }


    .user-list{
        position: absolute;
        left: 0;
        top: 30px;
        padding: 0px 14px;
        width: 100%;
        background: #6d8d23;
        overflow: hidden;
        height: 35px;
        text-align: left;
    }

    .show-users .user-list{
        right: 0px;
        height: 100px;
    }

    .user{
        margin: 5px 0;
        width: 100px;
        position: relative;
        height: 70px;
        overflow: hidden;
        display: inline-block;
        white-space: nowrap;
    }

    .user *{
        pointer-events: none;
    }

    .user .picture{

        position: absolute;
        color: white;
        left: 0;
        right: 0;
        top: 0;
        margin: auto;
        height: 50px;
        width: 50px;
    }

    .user .label{
        position: absolute;
        color: white;
        left: 0;
        bottom: 0px;
        width: 100%;
        justify-content: center;
        margin: 0;
        background: #6d8d23;
    }

.user-list.collapsed .user{
    height: 30px;
    width: 100px;
    margin-right: 5px;
}

.user-list.collapsed .user .label{
    position: relative;
    height: 30px;
    justify-content: flex-start;
    margin-left: 5px;
    width: 80px;
    overflow: hidden;
}

.user-list.collapsed .user .picture, .user-list.minimized .user .picture{
    position: relative;
    height: 20px;
    width: 20px;
    margin: 0px;
    display: inline-flex;
    top: 0px;
    left: initial;
    right: initial;
}

.user-list.minimized .user{
    width: 20px;
    height: 20px;
    margin-right: 4px;
}

.user-list.minimized .user .label{
    position: absolute;
    right: 0px;
    bottom: 2px;
    width: 12px;
    height: 12px;
    border-radius: 100px;
    margin: 0;
    left: initial;
    display: block;
    z-index: 10;
    background: #404040;
    align-content: center;

}

.toggle{
    position: absolute;
    right: 20px;
    height: 20px;
    width: 20px;
    cursor: pointer;
    color: #6d8d23;
    top: 90px;
}

.show-users .toggle{
    top: 140px;
}

.show-users .message-container{
    height: calc(100% - 85px);
    top: 90px;
}

</style>
